<ng-content></ng-content>


// WEBPACK FOOTER //
// ./~/ngx-markdown/ngx-markdown.d.ts.MarkdownComponent.html